import React from 'react';
import { NextPage } from 'next';
import BusinessConditionsTemplate from '@components/BusinessConditions/BusinessConditions';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';

interface IBusinessConditions {}

const BusinessConditions: NextPage<IBusinessConditions> = () => {
    const { t } = useTranslation();

    return (
        <>
            <HeaderTemplate />
            <ContentTemplate withPadding>
                <BusinessConditionsTemplate />
            </ContentTemplate>
            <FooterTemplate />
        </>
    );
};

export default BusinessConditions;
